var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('a-spin',{attrs:{"spinning":true,"tip":"拼命加载中"}},[_c('div',{staticStyle:{"width":"100%"},style:({height:_vm.height})})]):_c('div',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }